import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GetWelcome } from "../../../StateManagement/Reducers/DashboardState";
import SignUp from "../../../Assets/images/SignUp.png";
import {
  Modal,
  ModalContainer,
  Div,
  Image,
  Button,
  Text,
} from "../../StyledComponents";
import { ModalDialog } from "../../StyledComponents/AddCard/Styles";

const Welcome = (props) => {
  const dispatch = useDispatch();
  const PatName = useSelector((state) => state.TopNavbar.userDetails.patname);
  const [ModalAnimat] = useState(true);
  const Welcomepopup = useSelector((state) => state.Dashboard.Welcome);

  useEffect(() => {
    dispatch(GetWelcome());
  }, []);

  return (
    <Modal width="100%" height="100%" show={props.show}>
      <ModalContainer justifyContent="center">
        <ModalDialog animation={ModalAnimat} width="455px">
          <Div
            height="364px"
            width="455px"
            borderRadius="8px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding="30px"
            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
            backgroundColor="white"
          >
            <Image
              src={SignUp}
              height="185px"
              width="200px"
              margin="0px 0px 24px 0px"
            />

            <Text
              fontSize="16px"
              fontWeight="500"
              color="#2D3748"
              fontFamily="Inter"
              textAlign="center"
              lineHeight="1.5"
              mb="4px"
              px="20px"
            >
              Welcome to Vozo Patient Portal, <b>{PatName}</b>!
            </Text>
            <Text
              fontSize="16px"
              fontWeight="500"
              color="#2D3748"
              fontFamily="Inter"
              textAlign="center"
              lineHeight="1.5"
              mb="24px"
              px="20px"
            >
              Explore your appointments, personal details, health profile, test
              results and chat with your provider.
            </Text>

            <Button
              background="#407BFF"
              color="white"
              borderRadius="6px"
              padding="12px 32px"
              fontSize="14px"
              fontWeight="500"
              fontFamily="Inter"
              marginBottom="14px"
              onClick={props.ModalHide}
            >
              Continue
            </Button>
          </Div>
        </ModalDialog>
      </ModalContainer>
    </Modal>
  );
};

export default Welcome;
